var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBarg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 57.427s-3.694 20.149-17.463 20.149H22.463C8.694 77.576 5 57.427 5 57.427h90zM70.909 31.982l-2.103-9.558H47.649v9.558m32.705 21.942l-61.869-.122 4.649-18.792h53.06l4.16 18.914zM33.52 43.59a3.598 3.598 0 0 0-7.196 0v3.246a3.598 3.598 0 0 0 7.196 0V43.59zm12.929 0a3.598 3.598 0 0 0-7.196 0v3.246a3.598 3.598 0 0 0 7.196 0V43.59zm12.929 0a3.598 3.598 0 0 0-7.196 0v3.246a3.598 3.598 0 0 0 7.196 0V43.59zm12.929 0a3.598 3.598 0 0 0-7.196 0v3.246a3.598 3.598 0 0 0 7.196 0V43.59z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarg);
export default __webpack_public_path__ + "static/media/BARG.73f2f118.svg";
export { ForwardRef as ReactComponent };